import { type Currency } from 'types/IProduct';

const BGN_RATE = 1.95583;

const DUAL_DISPLAY_END = new Date('2026-07-01');

const isDualDisplayPeriod = (): boolean => new Date() < DUAL_DISPLAY_END;

const currencySymbols: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  BGN: 'лв.'
};

const getCurrencySymbol = (currency: Currency): string => currencySymbols[currency.name] || 'Unknown';

/**
 * Formats an amount with dual EUR/BGN display during the transition period
 * (until 2026-07-01). EUR is primary; BGN shown in brackets.
 * Outside the transition period, shows EUR only.
 */
const formatDualCurrency = (amount: number, currency: Currency): string => {
  let eurAmount: number;

  if (currency.name === 'BGN') {
    eurAmount = amount / BGN_RATE;
  } else {
    eurAmount = amount;
  }

  const eurFormatted = `€${eurAmount.toFixed(2)}`;

  if (isDualDisplayPeriod()) {
    const bgnAmount = (eurAmount * BGN_RATE).toFixed(2);
    return `${eurFormatted} (${bgnAmount} лв.)`;
  }

  return eurFormatted;
};

/**
 * Formats a plain EUR number with dual display (for hardcoded EUR contexts
 * like cart totals where there is no Currency object).
 */
const formatEurWithBgn = (amount: number): string => {
  const eurFormatted = `€${amount.toFixed(2)}`;

  if (isDualDisplayPeriod()) {
    const bgnAmount = (amount * BGN_RATE).toFixed(2);
    return `${eurFormatted} (${bgnAmount} лв.)`;
  }

  return eurFormatted;
};

export {
  getCurrencySymbol,
  formatDualCurrency,
  formatEurWithBgn
};
